import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Typography, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextInput from '../../../components/TextInput';

const GoalModal = ({ open, handleClose, currentGoal = 10000, onSave, type }) => {
  const [newGoal, setNewGoal] = useState(currentGoal);

  const handleSave = () => {
    onSave(newGoal);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '12px',
          padding: '8px',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 24px',
        }}
      >
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          Set Daily Goal
        </Typography>
        <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: '16px 24px' }}>
        <Grid container spacing={3} sx={{ marginTop: '2px' }}>
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Set your daily target for {type}
            </Typography>
            <TextInput
              label={`Daily Goal for ${type}`}
              type="number"
              value={newGoal}
              onChange={(e) => setNewGoal(Number(e.target.value))}
              inputProps={{ min: 0 }}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button
          onClick={handleClose}
          sx={{
            borderRadius: '50px',
            textTransform: 'none',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          sx={{
            borderRadius: '50px',
            textTransform: 'none',
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GoalModal;
